/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A membership row linking an MCP server into a meta MCP server's member set.
 */
export type MetaMcpMember = {
  /**
   * The ID of the membership
   */
  id: string;
  /**
   * The ID of the member MCP server
   */
  mcpServerId: string;
  /**
   * The name of the member MCP server, when configured
   */
  mcpServerName?: string | undefined;
  /**
   * The slug of the member MCP server, when configured
   */
  mcpServerSlug?: string | undefined;
  /**
   * The position of the member in the ordered member set
   */
  sortOrder: number;
};

/** @internal */
export const MetaMcpMember$inboundSchema: z.ZodMiniType<
  MetaMcpMember,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    mcp_server_id: z.string(),
    mcp_server_name: z.optional(z.string()),
    mcp_server_slug: z.optional(z.string()),
    sort_order: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_server_id": "mcpServerId",
      "mcp_server_name": "mcpServerName",
      "mcp_server_slug": "mcpServerSlug",
      "sort_order": "sortOrder",
    });
  }),
);

export function metaMcpMemberFromJSON(
  jsonString: string,
): SafeParseResult<MetaMcpMember, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MetaMcpMember$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MetaMcpMember' from JSON`,
  );
}
